'use client';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import reactHtmlParser from 'react-html-parser';
import { ImgParallax } from '@/src/components/common/ui/images/ImgParallax.jsx';
import { usePathname, useSearchParams } from 'next/navigation';
import Title from '@/src/components/common/ui/text/Title.jsx';
import { CURSOR_HIDE, CURSOR_SHOW } from 'haspr-cursor';
import { StyledInnerBanner } from '@/src/components/common/eco/sections/inner-banner/inner-banner.style.js';

const InnerBanner = ({ data, imageScroll }) => {

	const bannerImge = data?.images?.list?.find((f) => f?.banner === 'on');
	const pathname = usePathname();
	const searchParams = useSearchParams();
	const existingCategory = searchParams?.get('category') || '';

	// Use state for titleText
	const [titleText, setTitleText] = useState(data?.section_data?.short_desc || '');
	const [titleTextTop, setTitleTextTop] = useState(data?.section_data?.subtitle || '');
	const [descriptionTextTop, setdescriptionTextTop] = useState(data?.section_data?.description || '');

	useEffect(() => {
		if (pathname === '/products') {
			switch (existingCategory) {
				case 'girls':
					setTitleText("Girl's Apparel");
					setTitleTextTop("Trendy and Sustainable");
					setdescriptionTextTop("Eco Sourcing offers expertly crafted denim and woven garments for girls, partnering with top global brands to deliver both playful and stylish designs. Our two seasonal collections keep pace with fashion trends and meet the evolving tastes of young customers. We stand out for our creativity, commitment to quality, and dependable delivery, making us a trusted sourcing partner for global children’s apparel retailers.");
					break;
				case 'men':
					setTitleText("Men's Apparel");
					setTitleTextTop("Stylish and Classic");
					setdescriptionTextTop("At Eco Sourcing, we bring expertise and excellence to sourcing high-quality denim and woven garments for men. We work alongside leading global brands, offering a diverse range of styles from refined classics to modern fast fashion. Our dedicated seasonal collections ensure fresh, relevant designs each year, while our strong supply chain guarantees innovation, quality, and timely delivery. Retailers worldwide trust us as their go-to sourcing partner in men’s fashion.");

					break;
				case 'boys':
					setTitleText("Boy's Apparel");
					setTitleTextTop("Stylish and Comfortable");
					setdescriptionTextTop("Specializing in premium denim and woven garments for boys, Eco Sourcing partners with renowned global brands to provide a wide range of styles — from casual essentials to trend-driven looks. Our team develops four fresh collections each year, keeping offerings exciting and relevant. Eco Sourcing is recognized for its innovation, product quality, and reliable service, earning the trust of leading retailers in boys’ fashion.")
					break;
				case 'women':
					setTitleText("Women's Apparel");
					setTitleTextTop("Elegant and Sustainable");
					setdescriptionTextTop("Eco Sourcing is a leading apparel sourcing company specializing in premium denim and woven garments for women. We proudly collaborate with global brands like INDITEX, R-MIXED, Tiffosi, Villanova, and more, delivering both timeless classics and on-trend fast fashion. With two seasonal design collections each year, we inspire and attract top international retailers. Our monthly global shipments reflect our commitment to innovation, quality, and reliable delivery, making us a trusted partner in the women’s fashion market.")
					break;
				default:
					setTitleText(data?.section_data?.short_desc || '');
					setTitleTextTop(data?.section_data?.subtitle || '');
					break;
			}
		} else {
			// Reset to default if not on /products
			setTitleText(data?.section_data?.short_desc || '');
		}
	}, [pathname, existingCategory, data?.section_data?.short_desc]);



	return (
		<StyledInnerBanner  onMouseEnter={CURSOR_SHOW}
							onMouseLeave={CURSOR_HIDE} className={`InnerBanner ${pathname === '/tech-showcase' ? 'tech-showcase' : ''} ${imageScroll ? 'forImageScroll' : ''} ${bannerImge?.for_project === 'on' ? 'for_projects' : ''}`} >

			<ImgParallax  banner={true} alt={bannerImge?.short_title || 'Eco Sourcing Limited'} src={data?.images ? bannerImge?.full_path : ''} />

			<Container>
				<Row>
					<Col md={12} >

						<div className="title-wrapper-middle">
							<Title
								tag={'h2'}
								classname={`swiper__title`}
								text={titleTextTop}
								color={'#fff'}
								animClass={'no'}
								margin={'0 '}
							/>
							<Title
								tag={'h2'}
								animClass={'no'}
								classname={`swiper__title`}
								text={titleText}
								color={'#fff'}
								margin={'0 '}
							/>
						</div>

						<div className="description_only">
							{
								data?.section_data?.description &&
								<p className={``}>{descriptionTextTop}</p>

							}
						</div>
					</Col>
				</Row>
			</Container>
		</StyledInnerBanner>
	);
};


export default React.memo(InnerBanner);
